export type LoadScriptOptions = {
	scriptSrc: string
	scriptId: string

	onError: (message: string | Event, source?: string, lineno?: number, colno?: number, error?: Error) => void
	onLoad: () => void
}

function isScriptLoaded(scriptId: string): boolean {
	if (!document) {
		console.warn(`[scriptManager] document object is not defined. Cant check script (${scriptId})`)
		return false
	}

	const existingScript = document.getElementById(scriptId)
	return !!existingScript
}

function loadScript(options: LoadScriptOptions) {
	if (!document) {
		console.warn(`[scriptManager] document object is not defined. Cant load script (${options.scriptSrc})`)
		return
	}

	if (!options.scriptId) {
		console.warn('[scriptManager] options.scriptId is not defined')
		return
	}

	if (!options.scriptSrc) {
		console.warn('[scriptManager] options.scriptSrc is not defined')
		return
	}

	if (isScriptLoaded(options.scriptId)) {
		console.warn(`[scriptManager] Script with id ${options.scriptId} already loaded`)
		return
	}

	const script = document.createElement('script')
	script.id = options.scriptId
	script.src = options.scriptSrc

	script.onerror = (eventOrMessage, source, lineno, colno, error) => {
		options.onError(eventOrMessage, source, lineno, colno, error)
	}

	script.onload = () => {
		options.onLoad()
	}

	document.head.appendChild(script)
}

export default {
	isScriptLoaded,
	loadScript,
}
